import { Component } from '@angular/core';
import { NavController, NavParams, Events, ViewController } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';
import { CoSelfcheckAccountPage } from '../co-selfcheck-account/co-selfcheck-account';
import { CoBibItemComponent } from '../../components/co-bib-item/co-bib-item';

@Component({
  selector: 'page-co-bib-item',
  templateUrl: 'co-bib-item.html',
})
export class CoBibItemPage {
  private novelistDetails: any = {};
  private bibDetails: any;
  private style: string = "standard";
  private originalStyle: string;
  private sharedScreen: boolean = false;
  previousItems: Array<any> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private events : Events, private timeout : TimeoutFunctionsProvider, public viewCtrl: ViewController, private state: AppState, private sounds : SoundsProvider, private login : LoginProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.novelistDetails = this.navParams.get('novelistDetails');
    this.bibDetails = this.navParams.get('bibDetails');
    if(this.navParams.get('style'))this.style = this.navParams.get('style');
    if(this.navParams.get('style'))this.originalStyle = this.navParams.get('style');
    this.sharedScreen = this.state.sharedScreen;
    // console.log(this.bibDetails);
  }
  closeModal() {
    if (this.previousItems.length > 1){
      this.goToPreviousItem();
      // this.bibItemComponent.goToPreviousItem()
    } else {
      this.viewCtrl.dismiss().catch(err=>{});
    }
  }
  addItemToPreviousItemsArray(book){
    this.previousItems.push(book);
    console.log(this.previousItems)
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  logout($event){
    this.viewCtrl.dismiss().then(()=>{
      this.login.logout();
    }).catch((err) => this.login.logout());
  }
  myAccountClicked($event){
    this.viewCtrl.dismiss().then(() => {
      this.state.nav.push(CoSelfcheckAccountPage);
    }).catch((err) => {});
  }
  goToPreviousItem(){
    // this.previousItems.pop();
    this.previousItems = [this.previousItems[0]];
    this.events.publish('modalIsClosing');
    // console.log(this.previousItems);
    // console.log(this.previousItems, this.style);
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-bib-item/co-bib-item.ts